import { adminAPI } from 'services/admin';
import { useTableStore } from 'components/TableWithCheck/selectTableStore';
import { useAppHomeStore } from 'store/appHomeStore';
import { useNotification } from 'hooks/useNotification';
import { useCallback, useState } from 'react';

export const useHomeList = () => {
  const [loading, setLoading] = useState(true);
  const { setSelectedItems, setData, selectedItems } = useTableStore();
  const { appList, setAppList } = useAppHomeStore();
  const { openErrorNotification } = useNotification();

  const getHomeListData = useCallback(async () => {
    try {
      const data = await adminAPI.get('/admin/home-list');

      const listItems = data?.sort((a, b) => +a.sortNumber - +b.sortNumber);
      setAppList(listItems.map(i => ({ ...i, edit: false })));

      const mappedItems = listItems.reduce(
        (acc, current) => ({
          ...acc,
          [current.id]: [
            ...current.contents
              .sort((a, b) => +a.sortNumber - +b.sortNumber)
              .map(i => ({ ...i, id: i.contentId })),
          ],
        }),
        {}
      );

      setSelectedItems(mappedItems);
    } catch (error) {
      console.log(error);
      openErrorNotification({
        title: 'Erro ao buscar dados da Home List',
      });
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const uploadHomeList = async () => {
    try {
      const payload = appList.map((list, listIndex) => {
        const contents = selectedItems[list.id].map(
          (content, contentIndex) => ({
            contentId: content.contentId || content.id,
            contentType: content.contentType || content.type,
            sortNumber: contentIndex + 1,
          })
        );

        return {
          id: list.id,
          title: list.title,
          sortNumber: listIndex + 1,
          contents,
        };
      });

      if (payload.some(data => !data?.contents?.length)) {
        throw Error(
          'Não é possível salvar listas sem itens, verifique os dados'
        );
      }
      await adminAPI.put('/admin/home-list', {
        body: payload,
      });

      await getHomeListData();
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  return {
    loading,
    setData,
    uploadHomeList,
    getHomeListData,
  };
};
